import { dateFormat, dayFormat, getColor, timeFormat } from "../../tools";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

export default function eventReducer(event, { type, payload }) {
  switch (type) {
    case "SET_EVENT":
      //console.log("SET_EVENT");
      return payload;

    case "UPDATE_SURVEY":
      if (payload) {
        //console.log("SURVEY_CHANGE");
        return {
          ...event,
          ...{
            title: payload.name,
            itemId: payload.id,
            backgroundColor: getColor(payload.id),
          },
        };
      }
      return event;

    case "UPDATE_LOGIC":
      //console.log("LOGIC_CHANGE");
      if (payload.value === "at")
        return { ...event, ["end" + payload.index]: null };
      if (payload.value === "between")
        return {
          ...event,
          ["end" + payload.index]: moment(
            event["start" + payload.index],
            dateFormat
          )
            .add(1, "hour")
            .format(dateFormat),
        };
      return event;

    case "UPDATE_TIME":
      //console.log("TIME_CHANGE");
      if (payload.info)
        return {
          ...event,
          [payload.key]: moment(event[payload.key], dateFormat)
            .set({
              hour: moment(payload.value, "HH:mm").get("hour"),
              minute: moment(payload.value, "HH:mm").get("minute"),
            })
            .format(dateFormat),
        };
      return event;

    // FILL
    case "UPDATE_DAY":
      //console.log("UPDATE_DAY");
      return {
        ...event,
        [payload.key]: moment(event.start, dateFormat)
          .set({
            date: payload.value.get("date"),
            month: payload.value.get("month"),
            year: payload.value.get("year"),
          })
          .format(dateFormat),
      };

    case "ADD_TIME":
      //console.log("ADD_TIME");
      const index = uuidv4();
      const hoursToAdd = Object.keys(event).filter((key) =>
        key.startsWith("start")
      ).length;
      const date = moment(event.start, dateFormat).format(dayFormat);
      const time = moment(event.start, dateFormat)
        .add(hoursToAdd, "hour")
        .format(timeFormat);
      return {
        ...event,
        [`start${index}`]: `${date} ${time}`,
        [`end${index}`]: null,
      };

    case "DELETE_TIME":
      //console.log("DELETE_TIME");
      let deleteTime = { ...event };
      delete deleteTime["start" + payload];
      delete deleteTime["end" + payload];
      return deleteTime;

    case "ADD_REMINDER":
      //const defaultReminderInterval = { id: uuidv4(), value: 60 * 60 }; // in seconds
      const defaultReminderInterval = 60 * 60;
      return {
        ...event,
        reminderIntervals: [
          ...(event?.reminderIntervals ?? []),
          defaultReminderInterval,
        ],
      };

    case "UPDATE_REMINDER":
      if (payload.info) {
        let reminderIntervals = JSON.parse(
          JSON.stringify([...event.reminderIntervals])
        ); // make a copy
        reminderIntervals[payload.id] = Number(payload.value) * 60;
        return {
          ...event,
          reminderIntervals: reminderIntervals,
        };
      }
      return event;

    case "DELETE_REMINDER":
      const reminderIntervals = (event?.reminderIntervals ?? []).filter(
        (_, i) => i !== payload.id
      );
      return {
        ...event,
        reminderIntervals: reminderIntervals,
      };

    default:
      return event;
  }
}
